import React, { useState, useEffect } from "react";

/** Components */
import { Checkbox, Button, TableFooter, Table, TableBody, TableCell, TableRow, TableHead, TableContainer, Paper, TablePagination, Tooltip, ButtonGroup } from "@mui/material";
import EditUserGroup from "./editusergroup.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import AddIcon from "@mui/icons-material/Add";

/** Api & Function */
import { getGroupUsers, updateGroupUserStatus, getPermission, getMenu } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */
import { useTranslation } from "react-i18next";

/** Hook */
import { setDataFromBEState } from "../../../store/dataFromBESlice";
import { useDispatch, useSelector } from "react-redux";
import { useParamFilter } from "../../commons/customHook";

const UserGroup = () => {
  // boiler plate
  const [t] = useTranslation();
  const dispatch = useDispatch();

  // redux state
  const user = useSelector((state) => state.user.data);
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getGroupUsers);

  // state
  const [changeIds, setChangeIds] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN NHÓM NGƯỜI DÙNG"));
    fetchData();
    getPermission().then((res) => res.code === 200 && dispatch(setDataFromBEState({ permission: res.data })));
    getMenu().then((res) => res.code === 200 && dispatch(setDataFromBEState({ menu: res.data })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };

  const handleEditRoute = (e, row, index) => {
    if (e.target.type === "checkbox") return;
    setSelectedRow(row);
  };

  const handleUpdateStatus = (selectedStatus) => {
    return updateGroupUserStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button variant="outlined" onClick={() => setSelectedRow(false)}>
            <Tooltip title="Tạo mới">
              <AddIcon />
            </Tooltip>
          </Button>
          {/* <ButtonWithAPICallComponent title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "groupuser" })}>
            <RefreshIcon />
          </ButtonWithAPICallComponent> */}
        </ButtonGroup>
      </div>

      {loading ? (
        <LoadingProgress />
      ) : (
        <React.Fragment>
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    ID{" "}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                    {t("Tên nhóm")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                    {t("Mô tả")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>
                    <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length ? (
                  data.map((row, index) => (
                    <TableRow
                      key={row.id}
                      hover
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        handleEditRoute(e, row, index);
                      }}
                    >
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center" component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                        {row.name}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                        {row.description}{" "}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <EditUserGroup
            editable={Boolean(user?.organization_id === 1 || selectedRow?.id === user?.organization_id || user?.permissions?.UserGroup?.Update?.value === true)}
            initialData={selectedRow}
            // action={res => dispatch(setGroupUsers(data.map(item => item.id === res.id ? res : item)))}
            onSaveResponse={(res) => setData((prev) => prev.map((item) => (res.data?.id === item.id ? res.data : item)))}
            onCreateResponse={(res) => setData((prev) => [...prev, res.data])}
            onClose={() => setSelectedRow(null)}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default UserGroup;
